var map = {
	"./AQA/A/Biology/AQA_A_Biology_Questions.json": [
		81858,
		858
	],
	"./AQA/A/Chemistry/AQA_A_Chemistry_Questions.json": [
		77632,
		632
	],
	"./AQA/A/Physics/AQA_A_Physics_Questions.json": [
		66661,
		661
	],
	"./Demo_Questions.json": [
		18659
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 19267;
module.exports = webpackAsyncContext;